<template>
  <group-element
    :id="element.id"
    :toggle="toggle"
    v-bind="$attrs"
  >
    <template #default="{ select, group, parent }">
      <!-- The template that can be manipulated -->
      <element-renderer
        v-for="elementId in childElementsReversed"
        v-show="!getElementById(elementId)?.layerHiddenInGraphics"
        :id="elementId"
        :key="elementId"
        ref="children"
        :group="group"
        :type="getElementValueByProp(elementId, 'type')"
        :parent="parent"
        class="group-item"
        :toggle="toggle"
        @select="select"
      />
    </template>
  </group-element>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions, mapState } from 'vuex';
import elementsMixins from '../../../mixins/elements-mixins';
import GroupElement from '../Group.vue';
import shoppableDataModule from '../../../store/modules/shoppableData';

export default {
  name: 'Shoppable',
  inheritAttrs: false,
  components: {
    GroupElement,
    ElementRenderer: defineAsyncComponent(() => import('../ElementRenderer')),
  },
  mixins: [elementsMixins],


  computed: {
    ...mapState({
      // namespaced - arrow functions don't work here because of the scope of `this`
      // same with mapGetters
      product(state, getters) {
        return getters[`${[this.id]}/getProduct`];
      },
      formattedPrice(state, getters) {
        return getters[`${[this.id]}/getFormattedProductPrice`];
      },
      termsText(state, getters) {
        return getters[`${[this.id]}/getTermsText`];
      },
    }),
    childElements() {
      return this.getElementGroupMap[this.id] || [];
    },

    childElementsReversed() {
      return [...this.childElements]
        .reverse();
    },
  },
  async created() {
    // setup the dynamic store module for this social data instance
    const store = this.$store;
    const namespace = this.id;
    const stateModuleExists = store?.hasModule(namespace);
    // register a new module only if doesn't exist
    if (!stateModuleExists) {
      await store.registerModule(namespace, shoppableDataModule);
    }
  },
  methods: {
    ...mapActions('graphicsTemplate', [
      'addNewElement',
    ]),
  },
};
</script>
